<script>
import { App } from '@argon/app/components'

export default {
  extends: App
}
</script>
